export const backgroundColor = "#F3F4F6"
export const red6 = "#9a2100"
export const red70 = "#9C2628"
export const errorDark = "#AC1818"
export const neutral = "#696f88"
export const neutral30 = "#C2C7D0"
export const neutral70 = "#4D5165"
export const syngentaGreen = "#009933"
export const green4 = "#26AA62"
export const green5 = "#18884B"
export const green60 = "#14803C"
export const syngentaBlue = "#0B4C88"
export const blue1 = "#DDEFFF"
export const blue5 = "#2F78BB"
export const blue6 = "#0B4C88"
export const blue70 = "#005693"
export const greyC3 = "#c3c3c3"
export const grey2 = "#E0E0E0"
export const grey6 = "#444444"
export const grey7c = "#7c7c7c"
export const grey75 = "#757575"
export const grey85 = "#858585"
export const greyD9 = "#d9d9d9"
export const fuchsia6 = "#84142F"
export const greyF1 = "#F1F1F1"
export const yellow3 = "#FECE54"
export const themeColor = "#00A0BE"
export const lightPastelGreen="#F0F7F0"
export const white="#FFFFFF"
export const greyTxt="#99A1AF" 
export const labelColor="#0A0A0A"
export const black="#000000"
export const lightGrayish= "#F3F3F5"
export const darkGrayish= "#6E6E6E"
export const gray83 = "#838383"
export const red = "#d32f2f"
export const darkGrayBlue = "#4A5565";
export const lightGray   ="#EEEEEE";
export const  greyHeader = "#DEDEDE";
export const  greyDark = "#404040";
export const neutralDarkGray = "#545454";
export const infoBlue = "#E0EEFF";
export const successGreen = "#F0FDF4";
export const warningOrange = "#FFFBEB";

export const vividMediumGreen = "#00AC4F";



